import {
    SupervisorAction,
    SupervisorActionType,
} from '../actions/SupervisorActions';
import { User } from '../types';

const SupervisorReducer = (
    state: Array<User> = [],
    action: SupervisorAction
): Array<User> => {
    let updatedSupervisor: User;
    let supervisorIndex: number;
    switch (action.type) {
        case SupervisorActionType.GET_ALL_SUPERVISOR:
            return [...(action.payload as Array<User>)];
        case SupervisorActionType.PUT_SUPERVISOR_BENCHMARK:
            updatedSupervisor = (action.payload as { supervisor: User })
                ?.supervisor;
            supervisorIndex = state.findIndex(
                (supervisor) => supervisor?._id === updatedSupervisor?._id
            );
            state[supervisorIndex] = { ...updatedSupervisor };
            return [...state];
        case SupervisorActionType.PUT_SUPERVISOR_CAPACITY: {
            const updatedSupervisor = (action.payload as { supervisor: User })
                .supervisor;

            if (!updatedSupervisor) {
                return state;
            }

            supervisorIndex = state.findIndex(
                (supervisor) => supervisor?._id === updatedSupervisor?._id
            );
            state[supervisorIndex] = { ...updatedSupervisor };
            return [...state];
        }

        default:
            return state;
    }
};

export default SupervisorReducer;
